// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"FuvmDownloadButton_subTitle__1yCOR","title":"FuvmDownloadButton_title__3vii7","text":"FuvmDownloadButton_text__21oXb","footer":"FuvmDownloadButton_footer__2Fm27"};